import { parseISO } from 'date-fns';

// The audience filter keeps the picked date as a 'yyyy-MM-dd' string. Parse it with `parseISO`
// (local midnight): `new Date('yyyy-MM-dd')` is UTC midnight, which is the previous day west of
// UTC, so the picker showed the day before and the filter asked for the month before.
export const parseAudienceDate = (date: string | Date | null | undefined): Date =>
    typeof date === 'string' ? parseISO(date) : new Date(date);

export const formatDate = (date: string | Date | null | undefined): string => {
    const d = parseAudienceDate(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const formatDateToFirstOfMonth = (date: string | Date | null | undefined): string => {
    const d = parseAudienceDate(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}-01`;
};
